import DataGrid, { Column, Pager, Paging, Scrolling, SearchPanel, Summary, TotalItem } from 'devextreme-react/cjs/data-grid';
import React, { useEffect, useRef, useState } from 'react'
import { Button, Card, Modal } from 'react-bootstrap';
import { generateRepairBag, getRepairInvoice, GetRepairProductsList, getRepairReceipt } from '../services';
import CustomStore from 'devextreme/data/custom_store';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faFilePdf, faImage, faPenToSquare, faReceipt, faRecordVinyl } from '@fortawesome/free-solid-svg-icons';
import notistack from 'modules/core/notistack';
import PdfViewerModal from './PdfViewerModal';
import { useLocation, useNavigate } from 'react-router-dom';

const RepairProductList = () => {
    const [showPdfModal, setShowPdfModal] = useState(false);
    const [pdfData, setPdfData] = useState<string | null>(null);

    const location = useLocation();
    const openFirstReceipt = location.state?.openFirstReceipt;
    const [hasOpenedFirstReceipt, setHasOpenedFirstReceipt] = useState(false);
    const dataGridRef = useRef<any>(null);

    const dataSource = (): any | undefined => {
        return new CustomStore({
            key: 'id',
            load: async (loadOptions) => {
                try {
                    const { searchValue, skip, take } = loadOptions;
                    const parameterList = new URLSearchParams();
                    if (typeof skip === 'number') parameterList.append('skip', skip.toString());
                    if (typeof take === 'number') parameterList.append('take', take.toString());
                    const search = JSON.parse(JSON.stringify(loadOptions));
                    for (const [key, value] of Object.entries(search)) {
                        parameterList.append(key, JSON.stringify(value));
                    }
                    if (searchValue) {
                        parameterList.append("search", searchValue);
                    }
                    const response = await GetRepairProductsList(parameterList);
                    return {
                        data: response?.data || [],
                        totalCount: response?.data.length || 0,
                    };
                } catch (error) {
                    console.error("Data loading error:", error);
                    return { data: [], totalCount: 0 };
                }
            }
        });
    }

    const handleRepairReceipt = async (id: any) => {
        try {
            setShowPdfModal(true)
            const response = await getRepairReceipt(id)
            setPdfData(response.data)
        } catch (error: any) {
            notistack.error(error.message)
        }
    }

    const handleRepairInvoice = async (id: any) => {
        try {
            setShowPdfModal(true)
            const response = await getRepairInvoice(id)
            setPdfData(response.data)
        } catch (error: any) {
            notistack.error(error.message)
        }
    }

    const [repairProductIds, setRepairProductIds] = useState<any[]>([])
    console.log(repairProductIds)

    const handleRepairBag = async () => {
        try {
            if (repairProductIds.length > 0) {
                const payload = {
                    repairProductItemIds: repairProductIds,
                };
                const response = await generateRepairBag(payload)
                if (response.status == 200) {
                    reloadDataSource()
                    notistack.notifyFromApi(response)
                }
            }
            else {
                notistack.error('Please select at least one product');
            }
        } catch (error: any) {
            notistack.error(error.message)
        }
    }
    const [refreshKey, setRefreshKey] = useState(0);

    const navigate = useNavigate()
    const reloadDataSource = () => {
        setRefreshKey(prev => prev + 1);
    };
    const [showImageModal, setShowImageModal] = useState(false)
    const [imageLink, setImageLink] = useState('')

    useEffect(() => {
        const openFirstReceipt = location.state?.openFirstReceipt;
        const openSecondReceipt = location.state?.openSecondReceipt;

        if (!openFirstReceipt && !openSecondReceipt) return;

        const fetchAndOpen = async () => {
            try {
                const parameterList = new URLSearchParams();
                const response = await GetRepairProductsList(parameterList);
                const dataList = response?.data || [];
                let target;
                if (openFirstReceipt)
                    target = dataList.find((item: any) => item.repairWorkStatus !== "Closed");
                else if (openSecondReceipt)
                    target = dataList.find((item: any) => item.repairWorkStatus === "Closed");

                if (target) {
                    console.log(
                        `Auto-opening ${openFirstReceipt ? "receipt" : "invoice"} for:`,
                        target.id
                    );
                    if (openSecondReceipt) {
                        await handleRepairInvoice(target.id);
                    } else {
                        await handleRepairReceipt(target.id);
                    }
                }
            } catch (error: any) {
                notistack.error(error.message);
            }
        };

        fetchAndOpen();

        window.history.replaceState({}, document.title);
    }, [location.state]);


    return (
        <>
            <div className="page-content">
                <div className="container-fluid">
                    <Card>
                        <Card.Header className='d-flex justify-content-between align-items-center'>
                            <h5 className='m-0'>Repair Products List</h5>
                            <Button className="submit-btn" onClick={handleRepairBag}>
                                <FontAwesomeIcon icon={faArrowRight} />
                            </Button>
                        </Card.Header>
                        <Card.Body className="pt-0">
                            {/* {HasPermission("MetalColor.Read") ? */}
                            <DataGrid
                                dataSource={dataSource()}
                                showRowLines={true}
                                keyExpr="id"
                                columnAutoWidth
                                showBorders={true}
                                remoteOperations={{ groupPaging: true }}
                                key={refreshKey}
                                selection={{
                                    mode: 'multiple',
                                    showCheckBoxesMode: 'always'
                                }}
                                onSelectionChanged={(e) => {
                                    // Filter only checkable rows
                                    const validSelection = e.selectedRowsData.filter(row => row.isCheckable);
                                    const validIds = validSelection.map(row => row.id);

                                    // Deselect invalid (non-checkable) rows
                                    const invalidIds = e.selectedRowKeys.filter((_, i) => !e.selectedRowsData[i]?.isCheckable);
                                    if (invalidIds.length > 0) {
                                        e.component.deselectRows(invalidIds);
                                    }

                                    // Update your state with only valid IDs
                                    setRepairProductIds(validIds);
                                }}
                                onRowPrepared={(e) => {
                                    if (e.rowType === 'data' && !e.data.isCheckable) {
                                        setTimeout(() => {
                                            const row = e.rowElement;
                                            const checkboxCell = row.querySelector('.dx-command-select');

                                            if (checkboxCell) {
                                                const checkbox: HTMLInputElement | null = checkboxCell.querySelector('input[type="checkbox"]');
                                                if (checkbox) {
                                                    checkbox.disabled = true;
                                                    checkbox.title = "Selection not allowed for this row";

                                                    // Prevent click events from reaching DevExtreme selection logic
                                                    checkboxCell.addEventListener('click', (event) => {
                                                        event.stopPropagation();
                                                        event.preventDefault();
                                                    }, { once: true });
                                                }
                                            }
                                        }, 0);
                                    }
                                }}
                                onContentReady={(e) => {
                                    const hasData = e.component.totalCount() > 0;
                                    e.component.option("pager.visible", hasData);
                                    e.component.option("paging.visible", hasData);

                                    if (openFirstReceipt && !hasOpenedFirstReceipt) {
                                        const visibleRows = e.component.getVisibleRows();
                                        if (visibleRows.length > 0) {
                                            const firstRow = visibleRows[0].data;
                                            if (firstRow) {
                                                handleRepairReceipt(firstRow.id);
                                                setHasOpenedFirstReceipt(true);
                                            }
                                        }
                                    }
                                }}
                            >
                                <Scrolling
                                    mode='standard'
                                    useNative={true}
                                    scrollByContent={true}
                                    scrollByThumb={true}
                                />
                                <Pager
                                    showPageSizeSelector={true}
                                    allowedPageSizes={[10, 25, 50, 100]}
                                    showNavigationButtons={true}
                                    displayMode="full"
                                    showInfo={true}
                                />

                                <Summary>
                                    <TotalItem
                                    // column="repairWorkNo"
                                    // summaryType="count"
                                    // displayFormat="Total: {0} Repairs"
                                    />
                                </Summary>

                                <Paging defaultPageSize={10} />
                                <SearchPanel visible width={240} placeholder="Search..." />
                                <Column
                                    caption="Action"
                                    width={150}
                                    allowFiltering={false}
                                    cssClass="text-start"
                                    cellRender={({ data }) => (
                                        <div className="d-flex justify-content-start align-items-center gap-2">
                                            {data.repairWorkStatus == 'Ready to Pick Up' && (
                                                <button
                                                    className='btn btn-sm action-btn edit-btn'
                                                    title='edit payment details'
                                                    onClick={() => navigate(`/repair-product-details/${data.id}`)}
                                                >
                                                    <FontAwesomeIcon icon={faPenToSquare} className='ml-2' />
                                                </button>
                                            )}
                                            {data?.image && (
                                                <button
                                                    className="btn btn-sm action-btn"
                                                    title="Image"
                                                    onClick={() => {
                                                        setShowImageModal(true);
                                                        setImageLink(data.image);
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={faImage} className="ml-2 text-primary" />
                                                </button>
                                            )}
                                            <button className='btn btn-sm action-btn' title='Repair Receipt' onClick={() => handleRepairReceipt(data.id)}>
                                                <FontAwesomeIcon icon={faFilePdf} className="ml-2 " />
                                            </button>
                                            {data.repairWorkStatus == "Closed" && (
                                                <button className='btn btn-sm action-btn' title='Repair Invoice' onClick={() => handleRepairInvoice(data.id)}>
                                                    <FontAwesomeIcon icon={faFilePdf} className="ml-2 text-danger" />
                                                </button>
                                            )}
                                        </div>
                                    )}
                                />
                                <Column dataField="repairWorkNo" caption="Repair Work No" />
                                <Column dataField="customerName" caption="Customer Name" />
                                <Column dataField="netWt" caption="Net Wt" dataType="number" format="#,##0.000" />
                                <Column dataField="totalEstimateAmount" caption="Estimate Amount" dataType="number" format=" #,##0.00" />
                                <Column dataField="totalDueAmount" caption="Due Amount" dataType="number" format=" #,##0.00" />
                                <Column dataField="repairWorkStatus" caption="Status" />
                                <Column dataField="lastUpdate" sortOrder='desc' caption="Last Updated" dataType="datetime" format="dd/MM/yyyy" />

                            </DataGrid>

                            {/* :
                                <div className="text-center fs-5 fw-bold">
                                    <Result
                                        status="403"
                                        title="401"
                                        subTitle="Sorry, you are not authorized to access this data."
                                        className="custom-result"
                                    />
                                </div> */}
                            {/* } */}
                        </Card.Body>
                    </Card>
                </div>
            </div>


            <PdfViewerModal
                visible={showPdfModal}
                base64Data={pdfData}
                onClose={() => {
                    setShowPdfModal(false);
                    setPdfData(null);
                }}
            />

            {/* image modal */}
            <Modal show={showImageModal} onHide={() => setShowImageModal(false)} centered size="lg">
                <Modal.Header closeButton className=" text-white border-0">
                    <Modal.Title className="fs-5">Image Preview</Modal.Title>
                </Modal.Header>
                <Modal.Body className="bg-light d-flex flex-column align-items-center justify-content-center p-4">
                    <div
                        className="border rounded shadow-lg overflow-hidden"
                        style={{ maxHeight: "500px", maxWidth: "100%", borderColor: "#dee2e6" }}
                    >
                        <img
                            src={imageLink ?? ""}
                            alt="Preview"
                            className="img-fluid"
                            style={{ objectFit: "contain", height: "100%", width: "100%" }}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer className="bg-white border-0 d-flex justify-content-between">
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default RepairProductList
